import React from 'react';
import styles from './ErrorMessage.module.css';

export interface ErrorMessageProps {
  message?: string;
  children?: React.ReactNode;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  children,
  className,
}) => {
  const content = message || children;

  if (!content) return null;

  const classNames = [styles.error, className].filter(Boolean).join(' ');

  return (
    <div className={classNames} role="alert" aria-live="polite">
      <svg
        className={styles.icon}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clipRule="evenodd"
        />
      </svg>
      <span className={styles.message}>{content}</span>
    </div>
  );
};
